// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"9ee747bf","453":"cb0f1ead","626":"b4c18ccf"}[chunkId] + ".chunk.js";
};